import type { Accept, FileWithPath } from 'react-dropzone';

export const isImage = (file: FileWithPath) => {
  return file.type.split('/', 1)[0] === 'image';
};

export const convertBytesToMbsOrKbs = (filesize: number) => {
  let size: string;
  if (filesize >= 1_048_576) {
    size = `${filesize / 1_048_576} megabytes`;
  } else if (filesize >= 1024) {
    size = `${filesize / 1024} kilobytes`;
  } else {
    size = `${filesize} bytes`;
  }
  return size;
};

export const createFileFromUrl = async (url: string) => {
  const response = await fetch(url);
  const data = await response.blob();
  const metadata = { type: data.type };
  /*
   * `||`, а не `??`: `split` всегда возвращает непустой массив, поэтому `pop()`
   * здесь `undefined` не бывает — с `??` фолбэк был недостижим. Пустая строка
   * при этом бывает: у ссылки, кончающейся слэшем, последний сегмент пуст, и
   * файл без имени — не то, что нужно отдать в `new File`.
   */
  const filename = url.replace(/\?.+/, '').split('/').pop() || 'file';
  return new File([data], filename, metadata);
};

export const readFile = (file: FileWithPath) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', event => {
      resolve(event?.target?.result);
    });
    // eslint-disable-next-line unicorn/prefer-add-event-listener
    reader.onerror = event => {
      reader.abort();
      reject(event);
    };
    reader.readAsDataURL(file);
  });
};

const isDefined = (value: unknown) => {
  return value !== undefined && value !== null;
};

const isMIMEType = (value: string) => {
  return (value === 'audio/*' ||
  value === 'video/*' ||
  value === 'image/*' ||
  value === 'text/*' || /\w+\/[-+.\w]+/g.test(value));
};

const isExtension = (value: string) => {
  return /^.*\.\w+$/.test(value);
};

export const acceptPropertyAsAcceptAttribute = (accept: Accept): string => {
  if (isDefined(accept)) {
    return (
      Object.entries(accept)
        .flatMap(([mimeType, extension]) => [mimeType, ...extension])
        // Silently discard invalid entries as pickerOptionsFromAccept warns about these
        .filter(value => isMIMEType(value) || isExtension(value))
        .join(',')
    );
  }
  return '';
};

export const clearFileNames = (fileObjects: FileWithPath) => {
  const { name } = fileObjects;
  return name.replaceAll(/[^a-zA-Z0-9.\u{400}-\u{4FF}_-]/gu, '');
};
